import { render, staticRenderFns } from "./Textfield.vue?vue&type=template&id=dfc472d0"
import script from "./Textfield.vue?vue&type=script&lang=js"
export * from "./Textfield.vue?vue&type=script&lang=js"
import style0 from "./Textfield.vue?vue&type=style&index=0&id=dfc472d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports